module.exports = __webpack_public_path__ + "static/media/layers-white.de069a5c.svg";